export default "__VITE_ASSET__af457930__"